import React from "react";
import VolunteerForm from "../../components/PagesForm/VolunteerForm";

const UserAdd = () => {
  return <VolunteerForm isEdit={false} isAddVolunteer={false} />;
};

export default UserAdd;
